<div class="modal-body text-center gp-24 gpx-sm-72 gpy-sm-48">
  <img src="/assets/images/warning.svg" class="gmb-16" />

  <h6 class="h6-bold gmb-16">
    {{ 'JOTFORM.CLOSE_MODAL.TITLE' | translate }}
  </h6>

  <p class="p2-regular text-secondary gmb-24 gmb-md-32">
    {{ 'JOTFORM.CLOSE_MODAL.CONTENT' | translate }}
  </p>

  <div class="d-flex justify-content-center">
    <button
      type="button"
      class="gbtn-red-2 gbtn-sq b2-semibold gmx-8 gmx-md-12"
      [gptDataTrack]="
        analyticsId ? analyticsId + '-questionnaire-close-confirm' : null
      "
      (click)="modal.close(true)"
    >
      {{ 'JOTFORM.CLOSE_MODAL.CLOSE' | translate }}
    </button>
    <button
      type="button"
      class="gbtn-1 gbtn-sq b2-semibold gmx-8 gmx-md-12"
      [gptDataTrack]="
        analyticsId ? analyticsId + '-questionnaire-close-cancel' : null
      "
      (click)="modal.close(false)"
    >
      {{ 'JOTFORM.CLOSE_MODAL.CANCEL' | translate }}
    </button>
  </div>
</div>
